import { ErpCamposIntegracao } from 'px-business-components';

const hasCadastrosAdicionaisTotvs = camposIntegracao => camposIntegracao.natureza !== null;

export const hasCadastrosAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCadastrosAdicionaisTotvs(camposIntegracao);
  }
  return false;
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  return [true, null];
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      natureza: null,
    };
  }
  return null;
};
